<template>
  <b-form-group
    label="Açıklama"
    label-for="summary"
  >
    <validation-provider
      #default="{ errors }"
      name="Açıklama"
      rules="required"
    >
      <b-form-input
        id="summary"
        v-model="dataItem.summary"
        placeholder="Açıklama"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormInput,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'ProductConfigSummary',
  components: {
    BFormGroup,
    BFormInput,
    ValidationProvider,
  },
  data() {
    return {
      required,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['productConfig/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
